"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventArgs = void 0;
class EventArgs {
    constructor(__type, __typeName) {
        this.__type = __type;
        this.__typeName = __typeName;
    }
}
exports.EventArgs = EventArgs;
